// BXYZ:..:eliot@bosmanxyz.xyz:..:.www.bosmanxyz.xyz

(() => {
  const oppet = 'oppen';
  const stangt = 'stangd';
  const reducerad = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  const T = { snabb: 0.18, medium: 0.28, lang: 0.38 };

  const ladaIn = (panel, rader) => {
    if (!window.gsap || reducerad) return;
    window.gsap.fromTo(panel,
      { x: '100%' },
      { x: '0%', duration: T.lang, ease: 'power2.out' }
    );
    if (rader.length) {
      window.gsap.fromTo(rader,
        { y: 8, opacity: 0 },
        { y: 0, opacity: 1, duration: T.medium, ease: 'power2.out', delay: 0.08 }
      );
    }
  };

  const ladaUt = (panel, callback) => {
    if (!window.gsap || reducerad) {
      callback?.();
      return;
    }
    window.gsap.to(panel,
      { x: '100%', duration: T.medium, ease: 'power2.in', onComplete: callback }
    );
  };

  const radBort = (rad, callback) => {
    if (!window.gsap || reducerad) {
      rad.remove();
      callback?.();
      return;
    }
    window.gsap.to(rad, {
      height: 0,
      opacity: 0,
      duration: T.snabb,
      ease: 'power2.in',
      onComplete: () => { rad.remove(); callback?.(); },
    });
  };

  const radIn = (rad) => {
    if (!window.gsap || reducerad) return;
    window.gsap.fromTo(rad,
      { y: 8, opacity: 0 },
      { y: 0, opacity: 1, duration: T.medium, ease: 'power2.out' }
    );
  };

  const raknareBlipp = (el) => {
    if (!window.gsap || reducerad || !el) return;
    window.gsap.fromTo(el,
      { y: -6, opacity: 0 },
      { y: 0, opacity: 1, duration: T.snabb, ease: 'power2.out' }
    );
  };

  const hamtaLada = () => document.getElementById('varukorg-lada');
  const hamtaKnappar = () => document.querySelectorAll('[data-action~="varukorg/oppna"]');

  const uppdateraRaknare = (antal) => {
    document.querySelectorAll('.toppstapel__raknare').forEach((el) => {
      el.textContent = `(${antal})`;
      raknareBlipp(el);
    });
    document.querySelectorAll('[aria-label]').forEach((el) => {
      const etikett = el.getAttribute('aria-label');
      if (etikett && /cart/i.test(etikett)) {
        el.setAttribute('aria-label', etikett.replace(/\(\d+\)/, `(${antal})`));
      }
    });
  };

  const oppna = () => {
    const lada = hamtaLada();
    if (!lada) return;
    lada.hidden = false;
    lada.dataset.state = oppet;
    document.body.dataset.varukorgsOppen = 'true';
    hamtaKnappar().forEach((k) => k.setAttribute('aria-expanded', 'true'));

    const panel = lada.querySelector('.varukorg-lada__panel');
    const rader = [...lada.querySelectorAll('.varukorg-rad')];
    ladaIn(panel, rader);
  };

  const stang = (aterfokusMal) => {
    const lada = hamtaLada();
    if (!lada || lada.dataset.state !== oppet) return;
    const panel = lada.querySelector('.varukorg-lada__panel');

    ladaUt(panel, () => {
      lada.dataset.state = stangt;
      lada.hidden = true;
      document.body.dataset.varukorgsOppen = 'false';
      hamtaKnappar().forEach((k) => k.setAttribute('aria-expanded', 'false'));
      (aterfokusMal ?? document.querySelector('[data-action~="varukorg/oppna"]'))?.focus();
    });
  };

  const vaxla = () => {
    const lada = hamtaLada();
    if (!lada) return;
    lada.dataset.state === oppet ? stang() : oppna();
  };

  const kartAPI = async (url, body) => {
    const svar = await fetch(url, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify(body),
    });
    return svar.json();
  };

  const andraAntal = async (rad, delta) => {
    const nyckel = rad.dataset.nyckel;
    if (!nyckel) return;
    const varde = rad.querySelector('.varukorg-rad__antal-varde');
    const prisEl = rad.querySelector('.varukorg-rad__pris');
    const enhetspris = Number(rad.querySelector('[data-enhetspris]')?.dataset.enhetspris ?? 0);

    const nuvarande = Number(varde?.dataset.antal ?? 1);
    const nytt = Math.max(0, nuvarande + delta);

    const data = await kartAPI('/cart/change.js', { id: nyckel, quantity: nytt });
    if (data.error) return;

    if (nytt === 0) {
      radBort(rad, () => {
        uppdateraRaknare(data.item_count);
        uppdateraTotalpris(data.total_price);
      });
      return;
    }

    if (varde) {
      varde.textContent = nytt;
      varde.dataset.antal = nytt;
    }
    if (prisEl && enhetspris) {
      const format = new Intl.NumberFormat(document.documentElement.lang || 'en').format;
      prisEl.textContent = `${format(nytt * enhetspris / 100)} SEK`;
    }
    uppdateraRaknare(data.item_count);
    uppdateraTotalpris(data.total_price);
  };

  const fjernRad = async (rad) => {
    const nyckel = rad.dataset.nyckel;
    if (!nyckel) return;
    const data = await kartAPI('/cart/change.js', { id: nyckel, quantity: 0 });
    if (data.error) return;
    radBort(rad, () => {
      uppdateraRaknare(data.item_count);
      uppdateraTotalpris(data.total_price);
    });
  };

  const uppdateraTotalpris = (prisOre) => {
    const el = document.querySelector('.varukorg-lada__totalpris');
    if (!el) return;
    const kr = (prisOre / 100).toFixed(2).replace('.', ',');
    el.textContent = `${kr} SEK`;
    raknareBlipp(el);
  };

  const visaVarukorgFel = (form, meddelande) => {
    const el = form.querySelector('[data-varukorg-fel]');
    if (!el) return;
    el.textContent = meddelande || '';
    el.hidden = !meddelande;
  };

  const uppdateraLadaSektion = async () => {
    const rot = window.Shopify?.routes?.root || '/';
    const sektionSvar = await fetch(`${rot}?sections=varukorg-lada`, { headers: { Accept: 'application/json' } });
    if (!sektionSvar.ok) return false;
    const sektioner = await sektionSvar.json();
    const html = sektioner['varukorg-lada'];
    if (!html) return false;
    const tmp = document.createElement('div');
    tmp.innerHTML = html;
    const nyaRader = tmp.querySelector('.varukorg-lada__rader');
    const nyTotalpris = tmp.querySelector('.varukorg-lada__totalpris');
    const lada = hamtaLada();
    if (lada && nyaRader) {
      const befintligRader = lada.querySelector('.varukorg-lada__rader');
      if (befintligRader) befintligRader.replaceWith(nyaRader);
    }
    if (nyTotalpris) {
      const befintligTotalpris = document.querySelector('.varukorg-lada__totalpris');
      if (befintligTotalpris) befintligTotalpris.textContent = nyTotalpris.textContent;
    }
    return true;
  };

  document.addEventListener('submit', async (e) => {
    const knapp = e.submitter?.closest('[data-action~="varukorg/lagg-till"]')
      || e.target.querySelector('[data-action~="varukorg/lagg-till"]');
    if (!knapp) return;
    e.preventDefault();

    const form = e.target;
    form.synkaValdVariant?.();
    const info = form.closest('.produkt-sida__info');
    visaVarukorgFel(form, '');
    if (info && info.dataset.tillstand !== 'tillganglig') {
      const etikett = form.querySelector(`[data-knapp-etikett="${info.dataset.tillstand}"]`)?.textContent?.trim();
      visaVarukorgFel(form, etikett || 'Could not add to cart');
      return;
    }

    knapp.disabled = true;
    knapp.setAttribute('aria-disabled', 'true');

    try {
      const idInput = form.querySelector('[name="id"]');
      const variantId = idInput?.value;
      if (!variantId) {
        visaVarukorgFel(form, form.querySelector('[data-knapp-etikett="ogiltig"]')?.textContent?.trim() || 'Could not add to cart');
        return;
      }
      const payload = new FormData();
      payload.set('id', variantId);
      payload.set('quantity', '1');
      const svar = await fetch('/cart/add.js', {
        method: 'POST',
        headers: { Accept: 'application/json' },
        body: payload,
      });
      let data;
      try { data = await svar.json(); } catch (_) {
        visaVarukorgFel(form, 'Could not add to cart');
        return;
      }
      if (!svar.ok || data.status) {
        visaVarukorgFel(form, data.description || data.message || 'Could not add to cart');
        return;
      }

      let sektionOk = false;
      try { sektionOk = await uppdateraLadaSektion(); } catch (_) { sektionOk = false; }

      const cartSvar = await fetch('/cart.js', { headers: { Accept: 'application/json' } });
      if (!cartSvar.ok) {
        visaVarukorgFel(form, 'Added to cart, but cart could not be refreshed');
        return;
      }
      const cart = await cartSvar.json();
      uppdateraRaknare(cart.item_count);
      if (!sektionOk) uppdateraTotalpris(cart.total_price);
      oppna();
    } catch (_) {
      visaVarukorgFel(form, 'Could not add to cart');
    } finally {
      const farLaggasTill = !info || info.dataset.tillstand === 'tillganglig';
      knapp.disabled = !farLaggasTill;
      knapp.setAttribute('aria-disabled', knapp.disabled ? 'true' : 'false');
    }
  });

  document.addEventListener('click', (e) => {
    if (e.target.closest('[data-action~="varukorg/oppna"]')) {
      e.preventDefault();
      vaxla();
      return;
    }
    if (e.target.closest('[data-action~="varukorg/stang"]')) {
      stang();
      return;
    }
    const radMinska = e.target.closest('[data-action~="varukorg/antal-minska"]');
    if (radMinska) {
      andraAntal(radMinska.closest('.varukorg-rad'), -1);
      return;
    }
    const radOka = e.target.closest('[data-action~="varukorg/antal-oka"]');
    if (radOka) {
      andraAntal(radOka.closest('.varukorg-rad'), +1);
      return;
    }
    const fjernKnapp = e.target.closest('[data-action~="varukorg/fjern"]');
    if (fjernKnapp) {
      fjernRad(fjernKnapp.closest('.varukorg-rad'));
      return;
    }
  });

  document.addEventListener('keydown', (e) => {
    if (e.key !== 'Escape') return;
    stang();
  });
})();
